"use client";

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import CheckIcon from "@mui/icons-material/Check";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import CustomButton from "../components/CustomButton";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const dayMap: Record<string, number> = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 7,
};

const ChangeToneSettingPage = () => {
  const { state } = useLocation();

  const [rbtName, setRbtName] = useState("");
  const [rbtCode, setRbtCode] = useState("");

  const [settingFor, setSettingFor] = useState("default");
  const [friend, setFriend] = useState("");
  const [group, setGroup] = useState("");
  const [sendSms, setSendSms] = useState(false);

  const [date, setDate] = useState<Dayjs | null>(null);
    const [data, setData] = useState<any | null>(null);

  const [timeSetting, setTimeSetting] = useState("24 Hour");
  const [startHr, setStartHr] = useState("");
  const [endHr, setEndHr] = useState("");

  const [daySetting, setDaySetting] = useState("7 Days");
  const [days, setDays] = useState<number[]>([]);

  const [friendList, setFriendList] = useState<any[]>([]);
  const [groupList, setGroupList] = useState<any[]>([]);

  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );

  const { subType, planId } = useSelector((state: RootState) => state.profile);

  const navigate = useNavigate();

  useEffect(() => {
  const fetchProfile = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/Content/ProfileData?msisdn=${
          countryCode + msisdn
        }&service=${process.env.REACT_APP_SERVICE}&interface=${
          process.env.REACT_APP_INTERFACES
        }&langId=${process.env.REACT_APP_LANGID}&countryCode=${countryCode}`
      );

      const profile = data?.crbtProfile;

      setData(profile);        

      if (profile?.friendList) {
        setFriendList(profile.friendList);
      }

      if (profile?.groupList) {
        setGroupList(profile.groupList);
      }

    } catch (error) {
      console.error(error);
    }
  };

  fetchProfile();
}, [countryCode, msisdn]);

  useEffect(() => {
    if (!state) return;

    setRbtName(state.rbtName);
    setRbtCode(state.rbtCode);

    if (state.settingFor === "FRIEND") setSettingFor("Friend");
    else if (state.settingFor === "GROUP") setSettingFor("Group");
    else if (state.settingFor === "DATE") setSettingFor("Date");
    else setSettingFor("default");

    // FRIEND pre-select
if (state.friendName && state.fmsisdn) {
  setFriend(state.fmsisdn);
}

// GROUP pre-select
if (state.groupId !== -1 && state.groupId !== null) {
  setGroup(state.groupId.toString());
}

    setSendSms(state.settingFor === "FRIEND");

    if (state.date) {
  const parsedDate = dayjs(state.date, "DD-MM-YYYY");
  setDate(parsedDate.isValid() ? parsedDate : null);
}


    const sh = Number(state.stHr) / 100;
    const eh = Number(state.endHr) / 100;

    if (!isNaN(sh) && sh >= 0 && sh <= 23) {
      setStartHr(sh.toString());
      setTimeSetting("Set Time");
    }

    if (!isNaN(eh) && eh >= 0 && eh <= 23) {
      setEndHr(eh.toString());
      setTimeSetting("Set Time");
    }

    if (state.days === "8" || !state.days) {
  setDaySetting("7 Days");
  setDays([]);
} else {
  const arr = state.days.split("").map((d: string) => Number(d));
  setDays(arr.filter((n:any) => n >= 1 && n <= 7)); 
  setDaySetting("Set Days");
}

  }, [state]);

  const handleSetTone = async () => {
  try {
    const username = countryCode + msisdn;

    // ✔ friend-SMS allowed only for Friend setting
    const sendInfotoFmsisdn =
      settingFor === "Friend" ? (sendSms ? "1" : "0") : "0";

    // ✔ Include only the active setting's fields
    const selectedGroup = settingFor === "Group" ? group : "";
    const selectedFriend = settingFor === "Friend" ? friend : "";
    const formattedDate = date ? dayjs(date).format("DD-MM-YYYY") : "";
    const selectedDate = settingFor === "Date" ? formattedDate : "";

    // ✔ Time and days only apply for Default + Friend + Group
    const startHourValue =
      timeSetting === "Set Time" && settingFor !== "Date"
        ? Number(startHr) * 100
        : 2500;

    const endHourValue =
      timeSetting === "Set Time" && settingFor !== "Date"
        ? Number(endHr) * 100
        : 2500;

    const finalDays =
      settingFor === "Date"
        ? 8
        : daySetting === "7 Days"
        ? 8
        : days.join("");

    const data =
      "planId=" +
      planId +
      "&rbtCode=" +
      rbtCode +
      "&subType=" +
      subType +
      "&settingFor=" +
      settingFor +
      "&fmsisdn=" +
      selectedFriend +
      "&sendInfoToFmsisdn=" +
      sendInfotoFmsisdn +
      "&date=" +
      selectedDate +
      "&groupId=" +
      selectedGroup +
      "&stHr=" +
      startHourValue +
      "&endHr=" +
      endHourValue +
      "&days=" +
      finalDays;

    const apiUrl = `${process.env.REACT_APP_API_URL}/Purchase/SetRBT?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}&${data}`;

    const res = await axios.post(apiUrl);

    if (res?.data?.resCode === 231) {
      alert(res?.data?.resMessage);
      navigate('/flowtone/toneSetting');
    }
  } catch (err) {
    console.error(err);
    alert("Failed to set tone");
  }
};


  return (
    <Layout>
      <SidebarLayout>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Card sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
            <CardContent>
              <Typography
                variant="body1"
                fontWeight="bold"
                sx={{ borderBottom: "1px solid #ccc", pb: 1, mb: 2 }}
                textAlign="center"
              >
                FLOW TONE SETTING : {rbtName}
              </Typography>

              {/* --- SET FOR --- */}
              <Box
                sx={{ background: "#f0f0f0", p: 1, fontWeight: "bold", mb: 2 }}
              >
                Set For
              </Box>

              <Grid container spacing={2}>
                <Grid size={6}>
                  <RadioGroup
  value={settingFor}
  onChange={(e) => {
    const val = e.target.value;
    setSettingFor(val);

    // RESET other fields
    if (val === "default") {
      setFriend("");
      setGroup("");
      setDate(null);
    }

    if (val === "Friend") {
      setGroup("");
      setDate(null);
    }

    if (val === "Group") {
      setFriend("");
      setDate(null);
    }

    if (val === "Date") {
      setFriend("");
      setGroup("");
    }
  }}
>
                    <FormControlLabel
                      value="default"
                      control={<Radio />}
                      label="Set as Default"
                    />
                    <FormControlLabel
                      value="Group"
                      control={<Radio />}
                      label="Group"
                    />
                    <FormControlLabel
                      value="Friend"
                      control={<Radio />}
                      label="Friend"
                    />

                    
                      <Box sx={{ pl: 1.5 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                            disabled={settingFor !== "Friend" }
                              checked={sendSms}
                              onChange={(e) => setSendSms(e.target.checked)}
                            />
                          }
                          label="Send SMS to Friend"
                        />
                      </Box>
                   

                    <FormControlLabel
                      value="Date"
                      control={<Radio />}
                      label="Date"
                    />
                  </RadioGroup>
                </Grid>

                <Grid size={6}>
                  {/* GROUP */}
                  <FormControl
                    fullWidth
                    disabled={settingFor !== "Group"}
                    size="small"
                    sx={{ mb: 2, mt: 6 }}
                  >
                    <InputLabel>Select Group</InputLabel>
                    <Select
                      label="Select Group"
                      value={group}
                      onChange={(e) => setGroup(e.target.value)}
                    >
                      {groupList.map((g, i) => (
                        <MenuItem key={i} value={g.groupId}>
                          {g.groupName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* FRIEND */}
                  <FormControl
                    fullWidth
                    disabled={settingFor !== "Friend"}
                    size="small"
                    sx={{ mb: 2 }}
                  >
                    <InputLabel>Select Friend</InputLabel>
                    <Select
                      label="Select Friend"
                      value={friend}
                      onChange={(e) => setFriend(e.target.value)}
                    >
                      {friendList.map((f, i) => (
                        <MenuItem key={i} value={f.fmsisdn}>
                          {f.friendName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* DATE */}
                  <FormControl
                    fullWidth
                    disabled={settingFor !== "Date"}
                    size="small"
                  >
                    <DatePicker
                      label="DD-MM-YYYY"
                      value={date}
                      onChange={(newValue) => setDate(newValue)}
                      slotProps={{ textField: { size: "small" } }}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              {/* --- TIME --- */}
              <Box
                sx={{ background: "#f0f0f0", p: 1, mt: 3, fontWeight: "bold" }}
              >
                Time Setting
              </Box>

              <Grid container spacing={2}>
                <Grid size={6}>
                  <RadioGroup
                    value={timeSetting}
                    onChange={(e) => setTimeSetting(e.target.value)}
                  >
                    <FormControlLabel
                      value="24 Hour"
                      control={<Radio />}
                      label="24 Hour"
                    />
                    <FormControlLabel
                      value="Set Time"
                      control={<Radio />}
                      label="Set Time"
                    />
                  </RadioGroup>
                </Grid>

                <Grid size={6}>
                  {timeSetting === "Set Time" && (
                    <Grid container spacing={2} mt={1}>
                      <Grid size={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Select Start hour</InputLabel>
                          <Select
                            label="Select Start hour"
                            value={startHr}
                            onChange={(e) => setStartHr(e.target.value)}
                          >
                            {Array.from({ length: 24 }).map((_, i) => (
                              <MenuItem key={i} value={i}>
                                {i}:00
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid size={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Select End Hour</InputLabel>
                          <Select
                            label="Select End Hour"
                            value={endHr}
                            onChange={(e) => setEndHr(e.target.value)}
                          >
                            {Array.from({ length: 24 }).map((_, i) => (
                              <MenuItem key={i} value={i}>
                                {i}:00
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {/* --- DAYS --- */}
              <Box
                sx={{ background: "#f0f0f0", p: 1, mt: 3, fontWeight: "bold" }}
              >
                Day Setting
              </Box>

              <Grid container spacing={2}>
                <Grid size={6}>
                  <RadioGroup
                    value={daySetting}
                    onChange={(e) => setDaySetting(e.target.value)}
                  >
                    <FormControlLabel
                      value="7 Days"
                      control={<Radio />}
                      label="7 Days a week"
                    />
                    <FormControlLabel
                      value="Set Days"
                      control={<Radio />}
                      label="Set Days"
                    />
                  </RadioGroup>
                </Grid>

                <Grid size={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    disabled={daySetting !== "Set Days"}
                    sx={{ mt: 3 }}
                  >
                    <InputLabel>Select day of week</InputLabel>
                    <Select
                      label="Select day of week"
                      multiple
                      value={days}
                      onChange={(e) => {
  const value = e.target.value;
  const cleaned =
    typeof value === "string"
      ? value.split(",").map(Number)
      : value;

  // remove 8 or any invalid number
  setDays(cleaned.filter((n) => n >= 1 && n <= 7));
}}
                      renderValue={(selected) =>
                        selected
                          .map((num) =>
                            Object.keys(dayMap).find((k) => dayMap[k] === num)
                          )
                          .join(", ")
                      }
                    >
                      {Object.keys(dayMap).map((d) => (
                        <MenuItem key={d} value={dayMap[d]}>
                          {days.includes(dayMap[d]) && (
                            <CheckIcon fontSize="small" sx={{ mr: 1 }} />
                          )}
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* --- BUTTONS --- */}
              <Box mt={4} display="flex" gap={1} justifyContent="center">
                <CustomButton text="Set Tone" onClick={handleSetTone} />
                <CustomButton text="Reset" />
                <CustomButton text="Cancel" />
              </Box>
            </CardContent>
          </Card>
        </LocalizationProvider>
      </SidebarLayout>
    </Layout>
  );
};

export default ChangeToneSettingPage;
